import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { useFirstUpperCase } from "@/hooks/common/useUtils";

const brand = useFirstUpperCase(process.env.BRAND);
const country = document.body.dataset.originalSite?.toLocaleUpperCase();

export const useRedemptionCampaignApi = async () => {
  return await useScrmFetch(`/api/iscrm-redemption/website/redemption/campaign/list?brand=${brand}&country=${country}`).get().json();
}

export const useRedemptionSaveApi = async (params = {}) => {
  return await useScrmFetch(`/api/iscrm-redemption/giftRequestInfoApi/saveGiftRequestInfo`).post({
    ...params,
    brand,
    country
  }).json();
}